export default "__VITE_ASSET__BRM_WZnk__"